export default function() {
  return (
    <img alt="logo" src={require('../../assets/images/image-0.png')} style={{width: '100px'}} />
  );
}